import React, { Component, PropTypes } from 'react';
import styled from 'styled-components'
import { Field, arrayPush } from 'redux-form';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import S3Upload from './s3upload';

const SIGNY_HOST = 'http://signy.app.zeroone.st'

const StyledDropzone = styled(Dropzone)`
  position: relative;
`;

const ProgressBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;

  background-color: #eee;
`

const DropzoneLabel = styled.span`
  position: relative;
  z-index: 9;
`

class FileInput extends Component {
  static propTypes = {
    addFile: PropTypes.func.isRequired,

    accept: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    maxSize: PropTypes.number,
  }

  static defaultProps = {
    maxLength: 5,
    maxSize: 25,
  }

  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      percentage: 0,
      uploadErrors: [],
    };
  }

  onUploadProgress = (percentage) => {
    this.setState({ uploading: true, percentage });
  }

  onUploadError = (error) => {
    this.setState(({ uploadErrors }) => ({
      uploadErrors: [...uploadErrors, `Ошибка загрузки файла ${error}`]
    }));
  }

  onUploadFinish = (response) => {
    this.props.addFile(response);
    this.setState({ uploading: false });
  }

  onDrop = (droppedFiles) => {
    const { maxSize } = this.props;
    this.setState({ uploadErrors: [] });

    const files = droppedFiles.filter(({ name, size }) => {
      const valid = (size < 1024 * 1024 * maxSize);

      if (!valid) {
        this.setState(({ uploadErrors }) => ({
          uploadErrors: [...uploadErrors, `Файл ${name} превышает ${maxSize}Мб`]
        }));
      }

      return valid;
    });

    return new S3Upload({
      files,
      signingUrl: `${SIGNY_HOST}/s3/sign`,
      onProgress: this.onUploadProgress,
      onFinishS3Put: this.onUploadFinish,
      onError: this.onUploadError,
      contentDisposition: 'inline',
    });
  }

  renderFile = (field) => {
    const { input: { value: { publicUrl, filename } } } = field;
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${SIGNY_HOST}${publicUrl}`}
      >
        {filename}
      </a>
    );
  }

  renderCountLabel = (fields) => {
    const count = fields.length;

    return count > 0 ? (
      <span>
        {`
          ${count === 1 ? 'Загружен' : 'Загружено'}
          ${count}
          ${count === 1 ? 'файл' : count < 5 ? 'файла' : 'файлов'}
        `}
      </span>
    ) : null;
  }

  get dropButtonLabel() {
    const { maxLength } = this.props;
    const { uploading } = this.state;

    if (uploading) {
      return 'Загрузка...';
    }

    return maxLength > 1 ? 'Загрузить файлы' : 'Загрузить файл';
  }

  render() {
    const {
      fields,
      label,
      accept,
      maxLength,
      meta: { touched, error },
    } = this.props;
    const { uploadErrors, uploading, percentage } = this.state;

    return (
      <div>
        <div>
          {label}
          {touched && error && (
            <div>
              {error}
            </div>
          )}
        </div>
        <div>
          {fields.length < maxLength && (
            <StyledDropzone
              style={{}}
              onDrop={this.onDrop}
              accept={accept}
              multiple={maxLength > 1}
            >
              {uploading && <ProgressBar style={{ width: `${percentage}%` }} />}
              <DropzoneLabel>{this.dropButtonLabel}</DropzoneLabel>
            </StyledDropzone>
          )}
          {uploadErrors.map((uploadErr, index) => (
            <div key={index}>
              {uploadErr}
            </div>
          ))}
          {this.renderCountLabel(fields)}
          <ul>
            {fields.map((file, index) =>
              <li key={index}>
                <Field
                  name={file}
                  component={this.renderFile}
                />
                <button
                  onClick={() => fields.remove(index)}
                >
                  Удалить файл
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch, props) {
  const { formName, name } = props;

  return ({
    addFile: data => dispatch(arrayPush(formName, name, data)),
  });
}

export default connect(null, mapDispatchToProps)(FileInput);



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js